import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link,useHistory } from "react-router-dom"
import { useLocation, useParams } from "react-router"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import imageBaseUrl from '../../../helpers/imageBaseUrl'
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import {
  Address,
  EventNumberOfAttendees,
  EventBudget,
  Description,
  Ceremony,
  EventCreatedDate,
  EventCreatedBy,
  EventDate,
} from "./EventListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import { addNewVendor, deleteVendor, getVendors, updateVendor } from "../../../store/vendor/actions"
import { getEvents } from "../../../store/events/actions"
import { getVendor_event, updateVendor_event } from "../../../store/vendor_events/actions"


function EventsList() {
  const history = useHistory()
  const dispatch = useDispatch()
  const params = useParams()
  const location = useLocation()

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [vendor, setVendor] = useState([])
  const [offset,setOffset] = useState(0)
  const [page_size, setPageSize] = useState(10)
  const events = useSelector(state => state.vendors.vendor_event.data)
  const total_page = useSelector(state => state.vendors.vendor_event.total_page)
  const loading = useSelector(state => state.vendors.vendor_event.loading)

  useEffect(() => {
      dispatch(getVendor_event({id:params.vendor_id,page_size,offset }))
  }, [dispatch,offset,page_size])


  useEffect(() => {
    if (!isEmpty(events)) {
      setIsEdit(false)
    }
  }, [events])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setVendor(null)
    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const vendor = arg
    history.push('/events/add',vendor)
  }, [history])

  //delete vendor
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = vendor => {
    setVendor(vendor)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (vendor.id) {
      dispatch(deleteVendor(vendor))
    }
  }
  useEffect(() => {
    if(!loading){
      setDeleteModal(false)
           setModal(false) 
    } 

  }, [loading])
  const handleUserClicks = () => {
    // history.push('/events/add')
    dispatch(getEvents())
  }
  
  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },

      {
        Header: "Event date",
        accessor: "event_date",
        filterable: true,
        Cell: cellProps => {
          return <EventDate {...cellProps} />
        },
      },
      {
        Header: "Address",
        accessor: "address",
        filterable: true,
        Cell: cellProps => {
          return <Address {...cellProps} />
        },
      },
      {
        Header: "Ceremony",
        accessor: "ceremony_name",
        filterable: true,

        Cell: cellProps => {
          return <Ceremony {...cellProps} />
        },
      },
      {
        Header: "Description",
        accessor: "description",
        filterable: true,

        Cell: cellProps => {
          return <Description {...cellProps} />
        },
      },
      {
        Header: "Event budget",
        accessor: "event_budget",
        filterable: true,

        Cell: cellProps => {
          return <EventBudget {...cellProps} />
        },
      },
      {
        Header: "Event number of attendees",
        accessor: "event_number_of_attendees",
        filterable: true,

        Cell: cellProps => {
          return <EventNumberOfAttendees {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor_event({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    },null)
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor_event({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    },null)
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to={{
                      pathname: "/events/edit",
                      state: cellProps.row.original,
                    }}
                    className="text-primary"
                    // onClick={() => {
                    //   // console.log(cellProps.row)
                    //   const events =
                    //   handleUserClick(events)
                    // }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const events = cellProps.row.original
                      onClickDelete(events)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() =>
                          history.push(
                            `/events/events/${cellProps.row.original.id}`,
                            { vendor_name: cellProps.row.original.name }
                          )
                        }
                      >
                        Show events
                      </DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="MENU"
            breadcrumbItem={location?.state?.vendor_name}
          />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={events}
                    // isGlobalFilter={true}
                    isAddUsers={false}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody></ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
EventsList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default EventsList
